import { render } from "./DocumentTree.vue?vue&type=template&id=3c5d4660"
import script from "./DocumentTree.vue?vue&type=script&lang=js"
export * from "./DocumentTree.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__